import { useEffect, useState, useCallback } from "react";
import { detectCurrency } from "./pricingCurrency";

const KEY = "tradelog:ccy";

/**
 * Global currency selection. Persists to localStorage and broadcasts changes
 * via a synthetic `tradelog:ccy` window event so every mounted picker /
 * price stays in sync without needing a full context provider.
 */
export default function useCurrency() {
  const [ccy, setCcy] = useState(() => {
    if (typeof window === "undefined") return "INR";
    return localStorage.getItem(KEY) || detectCurrency();
  });

  useEffect(() => {
    const onChange = (e) => setCcy(e.detail || localStorage.getItem(KEY) || "INR");
    window.addEventListener("tradelog:ccy", onChange);
    return () => window.removeEventListener("tradelog:ccy", onChange);
  }, []);

  const update = useCallback((next) => {
    localStorage.setItem(KEY, next);
    window.dispatchEvent(new CustomEvent("tradelog:ccy", { detail: next }));
  }, []);

  return [ccy, update];
}
